// Library Class
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
// Class
import { MasterConstants } from '../../../../common/constants/master-constants';
import { FilterOption } from '../../../../common/components/filter/filter-model';
import { ControlType } from '../../../../common/components/filter/filter-enum';
import { CommonService } from './../../../../services/common/common.service';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
// Service Class
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { ExcelService } from './../../../../services/infrastructure/excel.service';
import { AssociateCropService } from './../../../../services/seed/associate-crop.service';


@Component({
  selector: 'app-associate-crop-landing',
  templateUrl: './associate-crop-landing.component.html',
  styleUrl: './associate-crop-landing.component.scss'
})
export class AssociateCropLandingComponent implements OnInit, AfterViewInit, OnDestroy {
  headerCompany = MasterConstants.US_COMPANYCODE;
  headerYear: any;
  validateEvolveData: any;
  ddlAccounts: any[] = [];
  userMenuAccessList: any;
  readOnlyAccess = false;
  filterOptionsData: Array<FilterOption>;
  subscription = new Subscription();
  masterConstants = MasterConstants;
  associateDataSource: MatTableDataSource<any>;
  @ViewChild('associateTable', { read: MatSort }) associateSort: MatSort;
  @ViewChild('associatePaginator', { read: MatPaginator }) associatePaginator: MatPaginator;
  associateOrderColumns: string[] = [];
  filter: AssociateOrderLandingFilterVM = new AssociateOrderLandingFilterVM();

  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private associateCropService: AssociateCropService,
    public excelService: ExcelService,
    private datePipe: DatePipe,
    private commonService: CommonService
  ) { }

  createNewReturn() {
    this.router.navigate(['/associate-crop/associate-crop-create-order']);
  }

  // ngOnInit
  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == MasterConstants.US_COMPANYCODE).userMenuAccessList;
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CROP_ASSOCIATES)) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CROP_ASSOCIATES, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          if (this.headerYear) {
            this.setFilterAndGridColumn();
            this.setDefaultFilter();
            this.getGridData(true);
          }
        } else {
          this.router.navigate(['/cc/landing-data']);
        }
      }
    }
   
  }


  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }


  // set account table height
  setAccSummaryTableHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.mat-mdc-tab-header').outerHeight() - $('.fulfill-top-sec').outerHeight() - 300;
      $('.activeReturnRequest').css('max-height', templateHeight + 'px');
    }, 100);
  }

  // Set Filter and Grid Columns
  setFilterAndGridColumn() {
    this.filterOptionsData = [
      { label: 'Account Name', key: 'accountNameList', controlType: ControlType.Text },
      { label: 'Account Number', key: 'accountNumberList', controlType: ControlType.Text },
      { label: 'Order Number', key: 'orderHeaderIdList', controlType: ControlType.Text },
      { label: 'Associate Location Name', key: 'locationNameList', controlType: ControlType.Text },
      { label: 'Crop Type', key: 'cropTypeCode', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id', isMultiSelect:false },
      { label: 'Variety', key: 'brandList', controlType: ControlType.Text },
      { label: 'Order Date', key: 'orderDate', controlType: ControlType.DateRange },
    ];
 
    this.associateOrderColumns = ['orderHeaderID', 'associateName', 'accountName',  'orderDate', 'brand', 'orderQty','orderUOM', 'status'];
  }

  // Set Drop down values for filter
  setDropDownValues(source) {
    const cropTypeList = this.getcropTypeList(source);
    if (cropTypeList && cropTypeList.length > 0) {
      this.filterOptionsData.find(x => x.key === 'cropTypeCode').controlData = cropTypeList ;
    } else {
      this.filterOptionsData.find(x => x.key === 'cropTypeCode').controlData = [];
    }
  }

  getcropTypeList(source) {
    let result = [];
    const seen = new Set();
    for (const item of source) {
      if (!seen.has(item.cropTypeCode)) {
        seen.add(item.cropTypeCode);
        result.push({ id: item.cropTypeCode, value: item.cropTypeDesc });
      }
    }
    result = result.sort((a, b) => a.value.localeCompare(b.value));
    return result;
  }

  // Set default filter values
  setDefaultFilter() {
    this.filter = {
      orderHeaderIdList: null,
      accountNumberList: null,
      accountNameList: null,
      locationNameList: null,
      cropTypeCode: null,
      brandList: null,
      orderFrom: null,
      orderTo: null,
    };
  }

  // ngOnDestroy
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // get data for both tabs
  getGridData(isfirstimeload:boolean) {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.associateCropService.GetSeedCropAssociatesLandingData(this.filter).subscribe((result: any[]) => {
      const associateOrderList = result && result.length > 0 ? result : [];
      if(isfirstimeload){
        this.setDropDownValues(associateOrderList);
      }
      this.associateDataSource = new MatTableDataSource(associateOrderList);
      this.associateDataSource.paginator = this.associatePaginator;
      this.associateDataSource.paginator.firstPage();
      this.associateDataSource.sort = this.associateSort;
      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  // Search Action
  filterSearchClick(event) {
    this.filter = event;
    this.getGridData(false);
  }

  // Clear All Action
  filterClearAllClick(event) {
    this.filter = event;
    this.getGridData(false);
  }

  // Navigate to selected order detail
  navigateOrderDetail(obj: any) {
    if (obj) {
      this.loaderService.setLoaderStatus(true);
      this.associateCropService.setseedAssociateOrderId(+obj.orderHeaderID);
      this.router.navigate(['/associate-crop/associate-crop-create-order']);
      this.loaderService.setLoaderStatus(false);
    }
  }

  public export() {
    const exportData = [];
    if (this.associateDataSource && this.associateDataSource.data.length > 0) {
      this.loaderService.setLoaderStatus(true);
      this.associateDataSource.data.forEach(x => {
        exportData.push({
          'Order Number': x.orderHeaderID,
          'Associate Location': x.associateName,
          'Associate City': x.associateCity,
          'Associate State': x.associateState,
          'Account Number': x.shipToAccount,
          'Account': x.accountName,
          'Account City': x.shipToCity,
          'Account State': x.shipToState,
          'Request By Date': this.datePipe.transform(x.orderDate, MasterConstants.DATE_MMDDYYYY),
          'Variety': x.brand,
          'Ordered Qty': x.orderQty,
          'UOM': x.orderUOM,
          'Status': x.status
        });
      });
      this.excelService.exportAsExcelFileWithDate(exportData, 'AssociateOrder');
      this.loaderService.setLoaderStatus(false);
    }
  }

  public generateReport() {
    this.loaderService.setLoaderStatus(true);
    let reportData = [];
    this.subscription.add(this.associateCropService.getSeedCropAssociateReport().subscribe((result: any[]) => {
      result.forEach(x => {
        reportData.push({
          'SDM Name': x.sdmName,
          'Associate Location Name': x.associateName,
          'City': x.city,
          'State': x.state,
          'Phone Number': x.phoneNumber,
          'Contact Name': x.contactName,
          'Brand ': x.variety,
          'Crop Type': x.cropType,
          'Available Quantity': x.availableQty
        });
      });
      this.excelService.exportAsExcelFileWithDateWithoutExport(reportData, 'Associate_Crop_Inventory_Availability_report_');
      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

}
export class AssociateOrderLandingFilterVM {
  orderHeaderIdList: number;
  accountNumberList: number;
  accountNameList: any;
  locationNameList: any;
  cropTypeCode: string;
  brandList: string;
  orderFrom: any;
  orderTo: any;
}
